import React from "react";
import { Link } from "react-router-dom";
import { Package, FileSearch, Users, Award } from "lucide-react";
import Layout from "../components/Layout";
import { useContent } from "../contexts/SiteContentContext";

const ICONS = [<Package className="w-5 h-5" />, <FileSearch className="w-5 h-5" />, <Users className="w-5 h-5" />, <Award className="w-5 h-5" />];

export default function ComoFunciona() {
  const c = useContent("como_funciona_page");
  const steps = c.steps || [];
  const faqItems = c.faq_items || [];

  return (
    <Layout>
      <section className="pt-20 pb-12 border-b border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <p className="section-tag mb-4">{c.eyebrow || "Procedimento"}</p>
          <h1 className="headline text-5xl md:text-7xl lg:text-8xl mb-6 leading-[0.9]">{c.title || "Como funciona"}</h1>
          <p className="text-bone-muted text-base md:text-lg max-w-2xl">{c.subtitle || ""}</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <div className="grid md:grid-cols-2 gap-px bg-white/10">
            {steps.map((s, i) => (
              <div key={s.n || i} className="bg-ink-50 p-10 md:p-14">
                <div className="flex items-center gap-4 mb-8">
                  <span className="text-blood">{ICONS[i % ICONS.length]}</span>
                  <span className="mono text-[10px] text-bone-faded tracking-[0.3em]">PASSO {s.n}</span>
                </div>
                <h3 className="headline text-3xl md:text-4xl mb-5">{s.t}</h3>
                <p className="text-bone-dim leading-relaxed">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {faqItems.length > 0 && (
        <section className="py-16 border-t border-white/10">
          <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-12">
            <div>
              <p className="section-tag mb-4">{c.faq_eyebrow || "FAQ"}</p>
              <h2 className="headline text-4xl md:text-5xl">{c.faq_title || "Perguntas frequentes"}</h2>
            </div>
            <div className="space-y-px bg-white/10">
              {faqItems.map((item, i) => (
                <div key={i} className="bg-ink-100 p-6">
                  <h4 className="headline text-lg mb-2">{item.q}</h4>
                  <p className="text-sm text-bone-muted leading-relaxed">{item.a}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      <section className="py-20 border-t border-white/10 text-center">
        <h2 className="headline text-4xl md:text-6xl mb-8">{c.cta_title || "Pronto para abrir o primeiro caso?"}</h2>
        <Link to="/casos" data-testid="how-it-works-cta">
          <button className="btn-primary mx-auto">{c.cta_button || "Ver casos disponíveis"}</button>
        </Link>
      </section>
    </Layout>
  );
}
